import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import TriColumnContainer from '../../components/tricolumncontainer';
import TriColumn from '../../components/tricolumn';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Language Support`}</h2>
    <p>{`GIPHY supports the following languages and offers unique regional content for many of the areas where these languages are spoken. You can leverage these benefits by passing the `}<inlineCode parentName="p">{`lang`}</inlineCode>{` param in your API request.`}</p>
    <TriColumnContainer title="Supported Languages" mdxType="TriColumnContainer">
      <TriColumn mdxType="TriColumn">
        <ul>
          <li parentName="ul">{`English (en)`}</li>
          <li parentName="ul">{`Spanish (es)`}</li>
          <li parentName="ul">{`Portuguese (pt)`}</li>
          <li parentName="ul">{`Indonesian (id)`}</li>
          <li parentName="ul">{`French (fr)`}</li>
          <li parentName="ul">{`Arabic (ar)`}</li>
          <li parentName="ul">{`Turkish (tr)`}</li>
          <li parentName="ul">{`Thai (th)`}</li>
          <li parentName="ul">{`Vietnamese (vi)`}</li>
          <li parentName="ul">{`German (de)`}</li>
          <li parentName="ul">{`Italian (it)`}</li>
        </ul>
      </TriColumn>
      <TriColumn mdxType="TriColumn">
        <ul>
          <li parentName="ul">{`Japanese (ja)`}</li>
          <li parentName="ul">{`Chinese Simplified (zh-CN)`}</li>
          <li parentName="ul">{`Chinese Traditional (zh-TW)`}</li>
          <li parentName="ul">{`Russian (ru)`}</li>
          <li parentName="ul">{`Korean (ko)`}</li>
          <li parentName="ul">{`Polish (pl)`}</li>
          <li parentName="ul">{`Dutch (nl)`}</li>
          <li parentName="ul">{`Romanian (ro)`}</li>
          <li parentName="ul">{`Hungarian (hu)`}</li>
          <li parentName="ul">{`Swedish (sv)`}</li>
          <li parentName="ul">{`Czech (cs)`}</li>
        </ul>
      </TriColumn>
      <TriColumn mdxType="TriColumn">
        <ul>
          <li parentName="ul">{`Hindi (hi)`}</li>
          <li parentName="ul">{`Bengali (bn)`}</li>
          <li parentName="ul">{`Danish (da)`}</li>
          <li parentName="ul">{`Farsi (fa)`}</li>
          <li parentName="ul">{`Filipino (tl)`}</li>
          <li parentName="ul">{`Finnish (fi)`}</li>
          <li parentName="ul">{`Hebrew (he)`}</li>
          <li parentName="ul">{`Malay (ms)`}</li>
          <li parentName="ul">{`Norwegian (no)`}</li>
          <li parentName="ul">{`Ukrainian (uk)`}</li>
        </ul>
      </TriColumn>
    </TriColumnContainer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      